import { createSvgIcon } from '@mui/material/utils';

export const StartIcon = createSvgIcon(
    <path d='M13.277 2.5a.998.998 0 00-1.73 0L8.832 7.176c-.191.328-.52.55-.895.61l-5.085.765c-.856.129-1.153 1.21-.489 1.761l3.79 3.137c.35.293.515.75.429 1.2l-.992 5.203a1 1 0 001.45 1.07l4.788-2.52c.367-.191.8-.191 1.164 0l4.79 2.52a1 1 0 001.448-1.07l-.992-5.204c-.082-.449.082-.906.434-1.199l3.789-3.136c.664-.551.363-1.633-.488-1.762l-5.09-.766a1.244 1.244 0 01-.89-.61zm0 0' />,
    'StartIcon'
);
